/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './notifyOfUpdate.defs'
export { main as default } from './notifyOfUpdate.defs'
